import GraphQLClient from 'ts/GraphQLClient'
import { RepoParams } from 'ts/types'
import { Budget, CreateBudgetParams, GetAllBudgetsParams, ReSubmitBudgetParams, SubmitReviewParams } from '../types'
import { CREATE_BUDGET, GET_ALL_BUDGETS, RESUBMIT_BUDGET, SUBMIT_REVIEW } from './graphql'

class BudgetsRepo {
  private client: GraphQLClient

  constructor({ GRAPHQL_URL, GRAPHQL_API_KEY }: RepoParams) {
    this.client = new GraphQLClient({ url: GRAPHQL_URL, apiKey: GRAPHQL_API_KEY })
  }

  async getBudgets({ token, year }: GetAllBudgetsParams): Promise<Budget[]> {
    const data = await this.client.request<{
      getAllBudgetsNew: {
        data: Budget[]
        error?: { message: string }
      }
    }>({
      query: GET_ALL_BUDGETS,
      variables: { token, year }
    })

    const { getAllBudgetsNew } = data

    if (getAllBudgetsNew.error) {
      throw new Error(getAllBudgetsNew.error.message || 'API error')
    }

    return getAllBudgetsNew.data
  }

  async createBudget(params: CreateBudgetParams): Promise<void> {
    await this.client.request({
      query: CREATE_BUDGET,
      variables: params
    })
  }

  async submitReview(params: SubmitReviewParams): Promise<void> {
    await this.client.request({
      query: SUBMIT_REVIEW,
      variables: params
    })
  }

  async reSubmitBudget(params: ReSubmitBudgetParams): Promise<void> {
    await this.client.request({
      query: RESUBMIT_BUDGET,
      variables: params
    })
  }
}

export default BudgetsRepo
